import React from "react";
import { Table } from "semantic-ui-react";
import PropTypes from "prop-types";
import { formatMoney } from "../../../../app/util/formatUtils";
import { getNombreMoneda } from "../../../../app/util/textCodeUtils";
import {
  getTextOption,
  TYPE_OPTIONS_TIPO_DOCUMENTO_IDENTIDAD,
} from "../../../../app/util/optionsUtils";

const TransferenciasCuentasIfisResumen = ({
  cuentaOrigen,
  bancoDestino,
  cuentaDestino,
  aplicaTipoCambio,
  tipoCambio,
  itfTransferencia,
  comisionTransferencia,
  codigoMonedaTransferencia,
  importeTotalTransferir,
  transferenciaExitosa,
  tipoDocumentoDestino,
  numeroDocumentoDestino,
  nombreTitularDestino,
  importeDebitarValidado,
  monedaDebitarValidado,
}) => {
  return (
    <>
      <Table singleLine>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Cuenta de origen:</Table.Cell>
            <Table.Cell>{cuentaOrigen}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Banco destino:</Table.Cell>
            <Table.Cell>{bancoDestino}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Número de cuenta destino:</Table.Cell>
            <Table.Cell>{cuentaDestino}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Documento destinatario:</Table.Cell>
            <Table.Cell>{`${getTextOption(
              tipoDocumentoDestino,
              TYPE_OPTIONS_TIPO_DOCUMENTO_IDENTIDAD
            )} - ${numeroDocumentoDestino}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Nombre destinatario:</Table.Cell>
            <Table.Cell>{nombreTitularDestino}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Comisión:</Table.Cell>
            <Table.Cell>{`${getNombreMoneda(
              codigoMonedaTransferencia
            )} ${formatMoney(comisionTransferencia)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Monto:</Table.Cell>
            <Table.Cell>{`${getNombreMoneda(
              codigoMonedaTransferencia
            )} ${formatMoney(importeTotalTransferir)}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>ITF:</Table.Cell>
            <Table.Cell>{`${getNombreMoneda(
              codigoMonedaTransferencia
            )} ${formatMoney(itfTransferencia)}`}</Table.Cell>
          </Table.Row>
          {aplicaTipoCambio === true && (
            <>
              <Table.Row active>
                <Table.Cell>Información adicional</Table.Cell>
                <Table.Cell />
              </Table.Row>
              <Table.Row>
                <Table.Cell>Tipo de cambio:</Table.Cell>
                <Table.Cell>{tipoCambio}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Monto a debitar:</Table.Cell>
                <Table.Cell>{`${getNombreMoneda(
                  monedaDebitarValidado
                )} ${formatMoney(importeDebitarValidado)}`}</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Monto a transferir:</Table.Cell>
                <Table.Cell>{`${getNombreMoneda(
                  codigoMonedaTransferencia
                )} ${formatMoney(importeTotalTransferir)}`}</Table.Cell>
              </Table.Row>
            </>
          )}
        </Table.Body>
      </Table>
    </>
  );
};
TransferenciasCuentasIfisResumen.propTypes = {
  cuentaOrigen: PropTypes.string.isRequired,
  cuentaDestino: PropTypes.string.isRequired,
  bancoDestino: PropTypes.string.isRequired,
  aplicaTipoCambio: PropTypes.bool.isRequired,
  tipoCambio: PropTypes.number,
  itfTransferencia: PropTypes.number.isRequired,
  comisionTransferencia: PropTypes.number.isRequired,
  codigoMonedaTransferencia: PropTypes.string.isRequired,
  importeTotalTransferir: PropTypes.number.isRequired,
  transferenciaExitosa: PropTypes.bool,
  tipoDocumentoDestino: PropTypes.string.isRequired,
  numeroDocumentoDestino: PropTypes.string.isRequired,
  nombreTitularDestino: PropTypes.string.isRequired,
  importeDebitarValidado: PropTypes.number.isRequired,
  monedaDebitarValidado: PropTypes.string.isRequired,
};

export default TransferenciasCuentasIfisResumen;
